import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import type { Nullable } from '../types/common'

const LOCAL_STORAGE_KEY_PREFIX = 'swile'

export const useLocalStorage = <T>(
  key: string,
  defaultValue?: T,
): [Nullable<T>, Dispatch<SetStateAction<Nullable<T>>>] => {
  const [value, setValue] = useState<Nullable<T>>(() => {
    const saved = window.localStorage.getItem(`${LOCAL_STORAGE_KEY_PREFIX}:${key}`)
    return saved ? JSON.parse(saved) : defaultValue ?? null
  })

  useEffect(() => {
    value === null
      ? window.localStorage.removeItem(`${LOCAL_STORAGE_KEY_PREFIX}:${key}`)
      : window.localStorage.setItem(`${LOCAL_STORAGE_KEY_PREFIX}:${key}`, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}
